import { service } from '../api/axios';
export async function downloadFile(url, params = {}, fileName) {
    try {
        const response = await service({
            url,
            method: 'get',
            params,
            responseType: 'blob',
        });
        // 创建隐藏的可下载链接
        const blob = new Blob([response]);
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName || '下载文件.xlsx';
        document.body.appendChild(link);
        link.click();
        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
    }
    catch (error) {
        console.error('下载失败', error);
    }
}
